// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2FUk7","containerItemsCenter":"Skeleton_containerItemsCenter__2god1"};